import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = ['Los manuales de "prepping" militar son pesados, caros y requieren equipo que no sabes usar.', 'Guardar documentos en la "nube" no sirve de nada si las torres de telefonía se caen durante un apagón.', 'Los botiquines de farmacia solo sirven para raspones, no para emergencias reales donde la ayuda no llega.', 'Prepararse "algún día" es lo que dice el 95% de la gente que termina durmiendo en el suelo de un refugio sin identificación.'];
  return <section className="py-24 px-4 bg-brand-gray border-t border-brand-border" data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <FadeIn data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white uppercase mb-12 text-center" data-id="element-18">
            Por qué lo que has intentado{' '}
            <span className="text-red-500" data-id="element-19">NO FUNCIONA</span>
          </h2>
        </FadeIn>

        <div className="grid gap-6" data-id="element-20">
          {failures.map((failure, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-21">
              <div className="flex items-start gap-4 p-6 bg-brand-dark border border-brand-border rounded-lg hover:border-red-500/50 transition-colors" data-id="element-22">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-23" />
                <p className="text-gray-300 text-lg" data-id="element-24">{failure}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}